import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'inviteMemberSpace',
  'createNewSpace',
  'removeMemberSpace',
  'deleteSpace',
  'leaveSpace',
  'addMoreMembersUpgradeClick',
  'addMembersUpgradeClick',
  'addMoreSpacesUpgradeClick',
  'teamSpaceUpgradeClick',
  'discoverTeamspaceLearnMore',
  'upgradeTeamspaceModalClickContactUs',
  'upgradeTeamspaceModalClickUpgrade',
  'upgradeTeamspaceModalShown',
] as const;

export const teamspacesEvents = getMappedEvents([...EVENTS]);
